import * as pageTypes from './pageTypes.js';
import * as actionTypes from './actionTypes';
import * as scanHelpers from './scans';

export const FETCH_DAYS = 60;
export const getParamsActionNames = pageType =>
{
  let actions = [];
  switch (pageType) {
    case pageTypes.CASEMETRICS:
      actions =
      [
        actionTypes.RETRIGGER,
        actionTypes.LABEL_AS_OUTLIER,
        actionTypes.COPY_FILE_PATH,
        actionTypes.OPEN_S3_PATH,
        actionTypes.OPEN_JOB_URL,
        actionTypes.RUN_WHATS_IN_JOB
      ];
      break;
    case pageTypes.PERFORMANCEMETRICS:
      actions =
      [
        actionTypes.RETRIGGER,
        actionTypes.LABEL_AS_OUTLIER,
        actionTypes.OPEN_JOB_URL,
        actionTypes.COPY_METRICS_FILE_PATH,
      ];
      break;
    case pageTypes.ARTIFACTSMETRICS:
    case pageTypes.ENGINEMETRICS:
      actions =
      [
        actionTypes.RETRIGGER,
        actionTypes.LABEL_AS_OUTLIER,
        actionTypes.OPEN_JOB_URL,
        actionTypes.COPY_FILE_PATH,
        actionTypes.OPEN_S3_PATH
      ];
      break;
    case pageTypes.EXPORTTESTS:
      actions = [
        actionTypes.RETRIGGER,
        actionTypes.LABEL_AS_OUTLIER,
        actionTypes.OPEN_JOB_URL,
        actionTypes.COPY_PERFORMANCE_METRICS_FILE_PATH
      ];
      break;
    case pageTypes.CASEAMENDINGTESTS:
      actions =
      [
        actionTypes.RETRIGGER,
        actionTypes.LABEL_AS_OUTLIER,
        actionTypes.OPEN_JOB_URL
      ];
      break;
    case pageTypes.CASEAMENDINGKPPTESTS:
      actions =
      [
        actionTypes.RETRIGGER,
        actionTypes.LABEL_AS_OUTLIER,
        actionTypes.OPEN_JOB_URL
      ];
      break;
  }
  return actions;
};

export const getMetricsActionNames = pageType =>
{
  let actions = [];
  switch (pageType) {
    case pageTypes.CASEMETRICS:
    case pageTypes.ENGINEMETRICS:
      actions =
      [
        actionTypes.OPEN_DIFF_VIEWER,
        actionTypes.BREAK,
        actionTypes.COPY_DIFF_RESULT_PATH,
        actionTypes.BREAK,
        actionTypes.OPEN_CHILD_JOB_URL,
      ];
      break;
  }
  return actions;
};

export const getNodeGroup = (nodeName) => {
  if (scanHelpers.matchVMNode(nodeName)) {
    return 'VM';
  }
  if (scanHelpers.matchSeriesNode(nodeName)) {
    const series = scanHelpers.matchSeriesNode(nodeName)[0][0];
    return `${series}.. Series`;
  }
  return 'Other';
};

// Markers used in the selection order tracker
export const DISPATCHER_MARKER = 'DISPATCHER_DROPDOWN';
export const IMAGE_MARKER = 'IMAGE_DROPDOWN';

/**
 * Get the order that dispatcher and image dropdowns
 * had their respective values selected
 *
 * This order helps determine filter behaviour
 */
export const getDropdownPairSelectionOrder = (currSelected, dispatcher, image) => {
  if (dispatcher && image) {
    // both selected from, curr not effected
    return currSelected;
  }

  // selecting a value for the first time OR
  // clearing one of the two values already selected does have effect
  if (dispatcher) {
    return DISPATCHER_MARKER;
  } else if (image) {
    return IMAGE_MARKER;
  }
  else {
    return '';
  }
};



// WEBPACK FOOTER //
// src/helpers/metricsPagesHelper.js